// this is the only action with meta.completed = true
export const completeOffline = () => ({
  type: 'OFFLINE_COMPLETE',
  meta: {
    completed: true
  }
});
